import React, { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import "./ConfidentialityAgreement.css"; // Import CSS file for styles
import { CheckIcon } from '@chakra-ui/icons';
import { Box } from "@chakra-ui/react";
import PDFViewer from "./PDFViewer";
import {useSearchParams} from 'react-router-dom';
import OTPModal from "../modal/OTPModal";
import { environment } from "../environments/environment";

const ConfidentialityAgreement = () => {
  const [formData, setFormData] = useState({
    employeeName: "",
    signedBy: "",
    nameofEmployee: "",
    dateofAgreement: "",
  });

  const [genOtp , setGeneratedOtp] = useState(null)
  const [enteredOtp , setEnteredOtp] = useState(null)
  const [isAgreementSigned , setIsAgreementSigned] = useState(null)

  const [pdfData,setPdfData] = useState(null);
  const [searchParams] = useSearchParams();
  const name = searchParams.get("name"); 
  const bKey = searchParams.get("bKey");
  const mobile = searchParams.get("mobile");
  

  useEffect(() => {
    console.log("search params" , name , bKey , mobile);
    const currentDate = new Date().toISOString().split("T")[0];
    console.log("cuureent date" , currentDate)
    setFormData((prevData) => ({
      ...prevData,
      dateofAgreement: currentDate,
      nameofEmployee:name,
      employeeName:name,
      signedBy:name
    }));

  }, []);

  const handleGenOtp = (data) => {
    setGeneratedOtp(data);
    console.log("Data received from child:", data);
  };

  const handleAgreementSigned = (data) => {
    setIsAgreementSigned(data);
    console.log("Data received from isAgreement:", data);
  };

  const handleEntOtp = (data) => {
    setEnteredOtp(data)
  }
  // Handle input changes
  const handleChange = (e) => {
    let { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const AgreeTerms = async() => {
    const parts = formData.dateofAgreement.split("-"); // Split by '-'
    const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
    console.log("formatteddate", formattedDate);
    console.log("genot and setotp" , genOtp ,enteredOtp)
    const payload = new FormData();
    payload.append("employeeName", formData.employeeName);
    payload.append("dateofAgreement", formattedDate);
    payload.append("signedBy", formData.signedBy);
    payload.append("nameofEmployee", formData.nameofEmployee);
    payload.append("is_agree", true);

    // payload.append("generated_otp", genOtp)
    // payload.append("entered_otp",enteredOtp)
    payload.append("businessKey" , bKey)
    try {
      const response = await axios.post(
        `${environment.bardWoodUrl}confidentiality-agreement`,
        payload
      , {
        responseType: "arraybuffer", // Fetch raw binary data
      });
      setPdfData(new Uint8Array(response.data)); // Convert ArrayBuffer to Uint8Array
      const blob = new Blob([pdfData], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
      console.log("type of response" , typeof(response.data))
      console.log("Response data:", response.data);
    } catch (error) {
      console.error("Error fetching PDF data:", error);
    }

  };

  const DeclineTerms = () => {
    const parts = formData.dateofAgreement.split("-"); // Split by '-'
    const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
    console.log("formatteddate", formattedDate);
    const payload = new FormData();
    payload.append("employeeName", formData.employeeName);
    payload.append("dateofAgreement", formattedDate);
    payload.append("signedBy", formData.signedBy);
    payload.append("nameofEmployee", formData.nameofEmployee);
    payload.append("is_agree", false);
    // payload.append("generated_otp", genOtp)
    // payload.append("entered_otp",enteredOtp)
    payload.append("businessKey" , bKey)

    axios
      .post(
        `${environment.bardWoodUrl}confidentiality-agreement`,
        payload
      )
      .then((res) => {
        console.log("ressss", res);
      });
  };

  return (
     <div className="confidential-agreement">
     <div className="otp-modal">
     <OTPModal mobile={mobile} businessKey={bKey} setGenOtp={handleGenOtp} setEntOtp={handleEntOtp} handleAgreementSigned={handleAgreementSigned} />
     </div>
     {!pdfData && !isAgreementSigned &&  <div className="agreement-container">
      {/* <h1 className="title">Welcome to BardWood Support Services</h1> */}
      <div className="headerTop">
      <h1 className="subtitle">Confidentiality <br /> Agreement</h1>
      </div>

      <div className="details-container">
      <p>
        <strong>BETWEEN:</strong>
      </p>
      <p>
        1. BardWood Support Services, [a company registered in England and Wales
        whose registered office is at Woodland Place, Hurricane Way, Wickford,
        Essex, SS11 8YB] and
      </p>
      <p>
        2. <strong>Employee Name:</strong>{" "}
        <input readOnly
          style={{ width: "200px" }}
          type="text"
          name="employeeName"
          value={formData.employeeName}
          onChange={handleChange}
          placeholder="Insert Employee Name Here"
        />
      </p>
      <p>
        <strong>WHEREAS:</strong>
      </p>
      <p>
        1. This Agreement is supplemental to the employment contract and terms
        of employment dated{" "}
        <strong>
          <input readOnly
            style={{ width: "200px" }}
            type="date"
            name="dateofAgreement"
            value={formData.dateofAgreement}
            onChange={handleChange}
            placeholder="DD/MM/YY"
          />
        </strong>{" "}
        between the Employer and the Employee. The Employee agrees to the
        following addition to their contract of employment with the Employer
        contained in the above-mentioned document.
      </p>
      <p>
        2. The Employee agrees to the following addition to his contract of
        employment with the Employer contained in the abovementioned document.
      </p>
      <br />
      <p>IT IS AGREED AS FOLLOWS</p>

      <div>
        <h3 className="section-title">1. Definitions and Interpretation</h3>
        <p>
          <strong>1.1</strong> In this Agreement, unless the context otherwise
          requires, the following expressions have the following meanings:
        </p>
        <p>
          <strong>“Confidential Information”</strong> means all information
          relating to the organisation, finances, processes, specifications,
          methods, designs, formulae, technology, business activities, and
          personnel details concerning BardWood support services.
        </p>

        <p>
          <strong>1.2</strong> Unless the context otherwise requires, each
          reference in this Agreement to:
        </p>
        <ul>
          <li>
            <strong>1.2.1</strong> “writing”, and any cognate expression,
            includes a reference to any communication effected by electronic or
            facsimile transmission or similar means;
          </li>
          <li>
            <strong>1.2.2</strong> a statute or a provision of a statute is a
            reference to that statute or provision as amended or re-enacted at
            the relevant time;
          </li>
          <li>
            <strong>1.2.3</strong> “this Agreement” is a reference to this
            Agreement and each of the Schedules as amended or supplemented at
            the relevant time;
          </li>
          <li>
            <strong>1.2.4</strong> a Clause or paragraph is a reference to a
            Clause of this Agreement (other than the Schedules) or a paragraph
            of the relevant Schedule;
          </li>
          <li>
            <strong>1.2.5</strong> a "Party" or the "Parties" refer to the
            parties to this Agreement; and
          </li>
          <li>
            <strong>1.2.6</strong> references to either gender shall include the
            other gender.
          </li>
        </ul>

        <p>
          <strong>1.3</strong> The headings used in this Agreement are for
          convenience only and shall have no effect upon the interpretation of
          this Agreement.
        </p>
        <p>
          <strong>1.4</strong> Words imparting the singular number shall include
          the plural and vice versa.
        </p>
      </div>
      <div>
        <h3 className="section-title">2. Operative Provisions</h3>
        <p>
          <strong>2.1</strong> The Employer has entered into an agreement with
          its customers for the <strong>PROVISION OF STAFF</strong> in the
          performance of which various of the Employer’s staff, including the
          Employee, will be provided with or obtain Confidential Information in
          respect of Customer requirements.
        </p>

        <p>
          <strong>2.2</strong> Except as authorised or required by his duties,
          the Employee shall keep secret and shall not use or disclose, and
          shall use his reasonable endeavours to prevent the use or disclosure
          by or to any person of, any of the Confidential Information which
          comes to his knowledge during his employment.
        </p>

        <p>
          <strong>2.3</strong> The restriction in sub-Clause 2.2 shall apply
          during the Employee’s employment and after termination of employment
          by either party for a period of one year, but shall cease to apply to
          information or knowledge which the Employee establishes has in its
          entirety become public knowledge otherwise than through any
          unauthorised disclosure or other breach on his part of that
          restriction.
        </p>

        <p>
          <strong>2.4</strong> All records in any medium (whether written,
          verbal, electronic or otherwise), including accounts, documents,
          drawings, and private notes about the Employer’s customers and its
          business, and all copies and extracts of them made or acquired by the
          Employee in the course of his employment shall (without prejudice to
          any other agreement between the Employer and the Customer) be:
        </p>
        <ul>
          <li>
            <strong>2.4.1</strong> the property of the Employer;
          </li>
          <li>
            <strong>2.4.2</strong> used for the purpose of the Employer only;
          </li>
          <li>
            <strong>2.4.3</strong> returned to the Employer on demand at any
            time; and
          </li>
          <li>
            <strong>2.4.4</strong> returned to the Employer without demand on
            the termination of the Employee’s employment.
          </li>
        </ul>

        <p>
          <strong>2.5</strong> No person other than the Employer and the
          Employee shall acquire any enforceable rights under or in connection
          with this agreement.
        </p>
      </div>

      <div>
        <h3 className="section-title">3. Non-Assignment of Agreement</h3>
        <p>
          No Party may assign, transfer, sub-contract, or in any other manner
          make over to any third party the benefit and/or burden of this
          Agreement without the prior written consent of the other Party or
          Parties.
        </p>
      </div>
      <div>
        <h3 className="section-title">4. Communication</h3>
        <p>
          <strong>4.1</strong> All notices under this Agreement shall be in
          writing and be deemed duly given if signed by the Party giving the
          notice or by a duly authorised officer thereof, as appropriate.
        </p>

        <p>
          <strong>4.2</strong> Notices shall be deemed to have been duly given:
        </p>
        <ul>
          <li>
            <strong>4.2.1</strong> when delivered, if delivered by courier or
            other messenger (including registered mail); or
          </li>
          <li>
            <strong>4.2.2</strong> when sent, if transmitted by facsimile or
            e-mail and a successful transmission report or return receipt is
            generated; or
          </li>
          <li>
            <strong>4.2.3</strong> on the fifth business day following mailing,
            if mailed by national ordinary mail, postage prepaid; or
          </li>
          <li>
            <strong>4.2.4</strong> on the tenth business day following mailing,
            if mailed by airmail, postage prepaid.
          </li>
        </ul>

        <p>
          <strong>4.3</strong> All notices under this Agreement shall be
          addressed to the most recent address, e-mail address, or facsimile
          number notified to the other Party.
        </p>
      </div>
      <div>
        <h3 className="section-title">5. Force Majeure</h3>
        <p>
          No Party to this Agreement shall be liable for any failure or delay in
          performing their obligations where such failure or delay results from
          any cause that is beyond the reasonable control of that Party. Such
          causes include, but are not limited to: power failure, Internet
          Service Provider failure, industrial action, civil unrest, fire,
          flood, storms, earthquakes, acts of terrorism, acts of war,
          governmental action or any other event that is beyond the control of
          the Party in question
        </p>
      </div>

      <div>
        <h3 className="section-title">6. Severance</h3>
        <p>
          The Parties agree that, in the event that one or more of the
          provisions of this Agreement is found to be unlawful, invalid or
          otherwise unenforceable, that / those provisions shall be deemed
          severed from the remainder of this Agreement. The remainder of this
          Agreement shall be valid and enforceable.
        </p>
      </div>

      <h3 className="section-title">7. Law and Jurisdiction</h3>
      <p>
        7.1 This Agreement (including any non-contractual matters and
        obligations arising therefrom or associated therewith) shall be governed
        by, and construed in accordance with, the laws of England and Wales.
      </p>
      <p>
        7.2 Any dispute, controversy, proceedings, or claim between the Parties
        relating to this Agreement (including any non-contractual matters and
        obligations arising therefrom or associated therewith) shall fall within
        the jurisdiction of the courts of England and Wales.
      </p>

      {/* <div className="agreement-section">
        <p className="agreement-text">
          IN WITNESS WHEREOF this Agreement has been duly executed the day and
          year first before written.
        </p>

        <div className="signature-section">
          <div className="signature-line">
            <label htmlFor="employer-signature">Signed By:</label>
            <input readOnly
              type="text"
              value={formData.signedBy}
              onChange={handleChange}
              name="signedBy"
              placeholder="Signed By"
            />
          </div>

          <div className="signature-line">
            <label htmlFor="employee-Name">Name of Employee:</label>
            <input readOnly
              type="text"
              value={formData.nameofEmployee}
              onChange={handleChange}
              name="nameofEmployee"
              placeholder="Employee's Name"
            />
          </div>
        </div>
        <div className="action-buttons">
          <button type="button" className="accept-button" onClick={AgreeTerms}>
            Accept
          </button>
          <button
            type="button"
            className="decline-button"
            onClick={DeclineTerms}
          >
            Decline
          </button>
        </div>
      </div> */}

<div className="agreement-section">
    <p className="agreement-title">In witness whereof</p>
    <p className="agreement-text">This Agreement has been duly executed the day and year first before written</p>
    <div className="form-container">
      <div className="input-group">
        <label htmlFor="signed-by">Signed By</label>
        <input readOnly type="text" id="signed-by" 
              name="signedBy"
              value={formData.signedBy}
              onChange={handleChange} placeholder="Signed By" />
      </div>
      <div className="input-group">
        <label htmlFor="employee-name">Name of Employee</label>
        <input readOnly type="text" id="employee-name" 
              name="nameofEmployee"
              value={formData.nameofEmployee}
              onChange={handleChange} placeholder="Name of employee" />
      </div>
    </div>
    <div className="action-buttons">
          <button type="button" className="accept-button" onClick={AgreeTerms}>
            Accept
          </button>
          <button
            type="button"
            className="decline-button"
            onClick={DeclineTerms}
          >
            Decline
          </button>
        </div>
    {/* <button className="submit-btn">Send</button> */}
  </div>

      <div>
    
      </div>
      </div>
    
    </div>}
    <div>
      {/* <h1>PDF Viewer</h1> */}
      {pdfData && (
        <PDFViewer pdfData={pdfData} />

      )}
      {pdfData && 
       <div className="modal-overlay">
      <div className="modal-content">
        <h2>Thank You!</h2>
        <p>PDF downloaded successfully.</p>
        <Box color="green.500" fontSize="50px">
          <CheckIcon />
        </Box>
      </div>
    </div>}
    </div>
     </div>
  );
};

export default ConfidentialityAgreement;
